import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import UILink from 'UIComponents/link/UILink';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { ComparePqlContext } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/name';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareFormsDisallowed = ({
  disabled = false
}) => {
  const {
    openUpgradeModal: __openUpgradeModal
  } = useUpgradeModal('forms-comparison-tool');
  const setIsShowingComparePql = useContext(ComparePqlContext);
  return /*#__PURE__*/_jsxs(UILink, {
    "data-test-id": "compare-forms-disallowed-href",
    disabled: disabled,
    onClick: () => {
      setIsShowingComparePql(true);
    },
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: 'dashboard.table.tableActions.compareForms'
    }), /*#__PURE__*/_jsx(UILockBadge, {})]
  });
};
export default CompareFormsDisallowed;